import { useState, useEffect, useMemo, Key } from "react";
import Link from "next/link";
import { Link as Element } from "react-scroll";
import styles from './DestinationsByPlace.module.css';
import NavBar from "./NavBar";
import wrappers from 'components/_styled/wrappers.module.css'
const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");

type Props = {
  places: object,
  url: any
}

const DestinationsByTown = ({ places, url }: Props) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const checkForMenuClose = (e) => {
    if (
      menuVisible &&
      e.target.id === 'cr-NEW-menu'
    )
      setMenuVisible(false);
  };

  useEffect(() => {
    window.addEventListener("click", checkForMenuClose);
    return () => {
      window.removeEventListener("click", checkForMenuClose);
    };
  });

  const alphabetisedPlaces = useMemo(() => {
    if (places) {
      const newAlphabetisedPlaces = {};

      for (const [key] of Object.entries(places)) {
        let letter = places[key].name.split("")[0].toLowerCase();

        if (letter in newAlphabetisedPlaces) newAlphabetisedPlaces[letter].push(places[key]);
        else newAlphabetisedPlaces[letter] = [places[key]];
      }

      Object.keys(newAlphabetisedPlaces).forEach((letter) => {
        newAlphabetisedPlaces[letter] = newAlphabetisedPlaces[letter].sort((a, b) => {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0;
        });
      });

      return newAlphabetisedPlaces;
    } else {
      return null;
    }
  }, [places]);

  return (
    <>
      <button className={styles.MenuButton} id="cr-NEW-menuButton" onClick={(e) => setMenuVisible(!menuVisible)}>
        Jump to letter
      </button>
      <NavBar
        menuVisible={menuVisible}
        closeMenu={() => {
          setMenuVisible(false);
        }}
        alphabetisedPlaces={alphabetisedPlaces || {}}
      />
      <div className={wrappers.FluidWrapper}>
        <div className={styles.wrapper}>
          <div className={styles.TownsWrapper}>
            {alphabetisedPlaces &&
              alphabet.map((letter) => {
                return (
                  <div className={styles.TownRow} key={letter}>
                    <Element name={`startsWith_${letter}`} to={`startsWith_${letter}`}/>
                    <h2>{letter.toUpperCase()}</h2>
                    <div>
                      {alphabetisedPlaces[letter] &&
                        alphabetisedPlaces[letter].map((place: { uri: any; id: Key; name: string }) => (
                          <Link href={url(place.uri)} key={place.id} prefetch={false}>
                            {place.name}
                          </Link>
                        ))}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default DestinationsByTown;
